"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesTaxResponse = exports.TaxRateBreakDown = exports.SalesTaxQuery = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.SalesTaxQuery = typebox_1.Type.Intersect([
    common_1.ServiceLocationTransport,
    typebox_1.Type.Object({
        bypassCache: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    }),
]);
exports.TaxRateBreakDown = typebox_1.Type.Object({
    city: typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()]),
    city_rate: typebox_1.Type.Optional(typebox_1.Type.String()),
    combined_district_rate: typebox_1.Type.Optional(typebox_1.Type.String()),
    combined_rate: typebox_1.Type.String(),
    country: typebox_1.Type.String(),
    country_rate: typebox_1.Type.Optional(typebox_1.Type.String()),
    county: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()])),
    county_rate: typebox_1.Type.Optional(typebox_1.Type.String()),
    freight_taxable: typebox_1.Type.Boolean(),
    state: typebox_1.Type.String(),
    state_rate: typebox_1.Type.Optional(typebox_1.Type.String()),
    zip: typebox_1.Type.String(),
});
exports.SalesTaxResponse = typebox_1.Type.Object({
    address: common_1.QuotePartialAddressWithZip,
    breakdown: exports.TaxRateBreakDown,
    combinedRate: typebox_1.Type.Number(),
});
//# sourceMappingURL=sales-tax.js.map